// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-password-validation-progress .password-validator-container .section-label {
  font-size: 14px;
}
.fi-password-validation-progress .password-validator-container .password-validation {
  color: var(--fi-color-light);
}
.fi-password-validation-progress .password-validator-container .password-validation.valid {
  color: var(--fi-color-green);
}
.fi-password-validation-progress .password-validator-container .password-validation.invalid {
  color: var(--fi-color-red);
}
.fi-password-validation-progress .password-validator-container .password-validation .mat-icon {
  text-align: center;
  line-height: 10px;
  height: 10px;
  vertical-align: middle;
}
.fi-password-validation-progress .password-validator-container .password-validation .mat-icon[hidden] {
  opacity: 0;
}
.fi-password-validation-progress .password-validator-container .password-validation .validation-label {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/password-validation-progress/password-validation-progress.component.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;AADZ;AAIQ;EACI,4BAAA;AAFZ;AAIY;EACI,4BAAA;AAFhB;AAKY;EACI,0BAAA;AAHhB;AAMY;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAJhB;AAMgB;EACI,UAAA;AAJpB;AAQY;EACI,eAAA;AANhB","sourcesContent":[".fi-password-validation-progress {\r\n    .password-validator-container {\r\n        .section-label {\r\n            font-size: 14px;\r\n        }\r\n\r\n        .password-validation {\r\n            color: var(--fi-color-light);\r\n\r\n            &.valid {\r\n                color: var(--fi-color-green);\r\n            }\r\n\r\n            &.invalid {\r\n                color: var(--fi-color-red);\r\n            }\r\n\r\n            .mat-icon {\r\n                text-align: center;\r\n                line-height: 10px;\r\n                height: 10px;\r\n                vertical-align: middle;\r\n\r\n                &[hidden] {\r\n                    opacity: 0;\r\n                }\r\n            }\r\n\r\n            .validation-label {\r\n                font-size: 12px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
